import axios from 'axios';

const api = axios.create({
    baseURL: 'https://backend.vaghtiar.ir/api', // یا آدرس سرور شما
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    }
});

// ارسال خودکار توکن لاگین به همراه تمام درخواست‌ها
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

export default api;
